<template>
    <div>
        <div class="grid grid-cols-1 gap-6">
            <div>
                <div class="flex justify-between items-center mt-16 mb-5">
                    <element-title>
                        {{ $t('profit_and_loss.recent') }}
                    </element-title>
                </div>

                <table-base class="text-sm w-full" :busy="isLoadingProfitAndLoss" card>
                    <template #head>
                        <slot name="table-head">
                            <table-head>{{ $t('general.store') }}</table-head>
                            <table-head>{{ $t('general.type') }}</table-head>
                            <table-head>{{ $t('date.date') }}</table-head>
                            <table-head>{{ $t('date.updated_at') }}</table-head>
                            <table-head></table-head>
                        </slot>
                    </template>
                    <template #body>
                        <table-row v-for="entry in recentProfitLoss" :key="entry.id">
                            <table-cell>
                                {{ entry.store.name }}
                            </table-cell>
                            <table-cell>
                                {{ $t('general.' + entry.type) }}
                            </table-cell>
                            <table-cell>
                                <template v-if="entry.entity.date">
                                    <template v-if="entry.type.endsWith('Extrapolation')">
                                        {{ $moment(entry.entity.date).format('D. MMMM Y') }}
                                    </template>
                                    <template v-else>
                                        {{ $moment(entry.entity.date).format('MMMM Y') }}
                                    </template>
                                </template>
                            </table-cell>
                            <table-cell>
                                {{ $moment(entry.entity.updated_at).format('D. MMMM Y H:m:s') }}
                            </table-cell>
                            <table-cell no-padding
                                        class="transition cursor-pointer bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-900 text-gray-900 dark:text-white">
                                <inertia-link class="flex justify-center items-center h-full w-full"
                                              :href="route('stores.profit-and-loss.edit', [entry.store.id, $moment(entry.entity.date).year(), $moment(entry.entity.date).month() + 1])">
                                    <icon name="chevron-right"></icon>
                                </inertia-link>
                            </table-cell>
                        </table-row>
                    </template>
                </table-base>
            </div>

            <div>
                <div class="flex justify-between items-center mt-16 mb-5">
                    <element-title>
                        {{ $t('budget.recent') }}
                    </element-title>
                </div>

                <table-base class="text-sm w-full" :busy="isLoadingBudgets" card>
                    <template #head>
                        <slot name="table-head">
                            <table-head>{{ $t('general.store') }}</table-head>
                            <table-head>{{ $t('date.year') }}</table-head>
                            <table-head>{{ $t('date.updated_at') }}</table-head>
                            <table-head></table-head>
                        </slot>
                    </template>
                    <template #body>
                        <table-row v-for="entry in recentBudgets" :key="entry.id">
                            <table-cell>
                                {{ entry.store.name }}
                            </table-cell>
                            <table-cell>
                                {{ entry.budget.year }}
                            </table-cell>
                            <table-cell>
                                {{ $moment(entry.budget.updated_at).format('D. MMMM Y H:m:s') }}
                            </table-cell>
                            <table-cell no-padding
                                        class="transition cursor-pointer bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-900 text-gray-900 dark:text-white">
                                <inertia-link
                                    :href="route('stores.budgets.edit', [entry.store.id, entry.budget.id])">
                                    <div class="flex justify-center items-center h-full w-full">
                                        <icon name="chevron-right"></icon>
                                    </div>
                                </inertia-link>
                            </table-cell>
                        </table-row>
                    </template>
                </table-base>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoadingProfitAndLoss: true,
            isLoadingBudgets: true,
            recentProfitLoss: [],
            recentBudgets: [],
        };
    },

    mounted() {
        axios.get(route('api.stores.profit-and-loss.recent-changes')).then(response => {
            this.recentProfitLoss = response.data;
            this.isLoadingProfitAndLoss = false;
        });

        axios.get(route('api.stores.budgets.recent-changes')).then(response => {
            this.recentBudgets = response.data;
            this.isLoadingBudgets = false;
        });
    },
};
</script>
